export default "__VITE_ASSET__9e83e185__"